module.exports = __webpack_public_path__ + "static/media/15a-03_ST-2015-405x295mm-oleo-sobre-papel.7022ec26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15a/15a-03_ST-2015-405x295mm-oleo-sobre-papel.jpg
// module id = 156
// module chunks = 0